import * as React from 'react'
import { connect } from 'react-redux'

import { Form, Input, Label, FormGroup } from 'reactstrap'

import { OptionsType, ValueType } from 'react-select/lib/types'

import { RootState } from '../../../store/rootReducer'
import { Location } from '../../../lib/interfaces/Location.interface'
import { ApplicationFilterParameters } from 'src/lib/interfaces/ApplicationFilterParameters.interface'
import { orderedApplicationStatus, applicationStatusToString } from 'src/lib/interfaces/ApplicationStatus.interface'

import CustomSelect from 'src/common/CustomSelect.component'

import * as appSelectors from 'src/store/app/selectors'

const get = require('lodash/get')
const first = require('lodash/first')
const isEmpty = require('lodash/isEmpty')

const moment = require('moment')

export interface ApplicationFilterProps {
  locations?: Location[]
}

export interface ApplicationFilterPassedProps {
  showEmployeeNameChecked?: boolean
  filterParams: ApplicationFilterParameters
  onChange: (filters: ApplicationFilterParameters) => void
}

class ApplicationFilter extends React.PureComponent<ApplicationFilterProps & ApplicationFilterPassedProps> {
  constructor(props) {
    super(props)

    this.multiSelectFilterChanged = this.multiSelectFilterChanged.bind(this)
    this.singleSelectFilterChanged = this.singleSelectFilterChanged.bind(this)
  }

  updateValueFromFilterChange(propertyName: string, value: any) {
    this.updateMultipleValuesFromFilterChange({ [propertyName]: value })
  }

  updateMultipleValuesFromFilterChange(values) {
    const { onChange, filterParams } = this.props
    const newFilterParams = {
      ...filterParams,
      ...values
    }
    
    onChange(newFilterParams)
  }

  singleSelectFilterChanged(propertyName: string, selectedOption: ValueType<any>) {
    this.updateValueFromFilterChange(propertyName, selectedOption.value)
  }

  multiSelectFilterChanged(propertyName: string, selectedOptions: OptionsType<any>) {
    this.updateValueFromFilterChange(propertyName, selectedOptions.map(({ value }) => value))
  }

  handleSelectLocation(value) {
    this.updateMultipleValuesFromFilterChange({
        location: value
    })
  }

  render() {
		const { locations, filterParams } = this.props

    return (
      <div>
        <Form>
          <FormGroup>
            <div className="row">
              <div className="col-3">
                <FormGroup>
                  <Label for="location">Location</Label>
                  <CustomSelect
										isMulti
                    options={locations}
                    style={{ width: '100%' }}
                    value={filterParams.location}
                    valueContainerStyle={{ textAlign: 'left' }}
                    getOptionValue={option => option && option.id }
                    getOptionLabel={option => option && option.code }
                    placeholderStyle={{ fontWeight: 'light', fontStyle: 'italic' }}
										onChange={(values: number[]) => this.updateValueFromFilterChange('location', values)}
                  />
                </FormGroup>
              </div>

							<div className="col-3">
                <FormGroup>
                  <Label for="location">Status</Label>
                  <CustomSelect
										isMulti
                    style={{ width: '100%' }}
                    value={filterParams.status}
                    getOptionValue={status => status}
                    options={orderedApplicationStatus}
                    valueContainerStyle={{ textAlign: 'left' }}
                    getOptionLabel={status => applicationStatusToString(status)}
										placeholderStyle={{ fontWeight: 'light', fontStyle: 'italic' }}
										onChange={(values: number[]) => this.updateValueFromFilterChange('status', values)}
                  />
                </FormGroup>
              </div>
            </div>
          </FormGroup>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
	locations: state.app.locations
})

const mapDispatchToProps = (dispatch) => ({})

export default connect<{}, {}, ApplicationFilterPassedProps>(mapStateToProps, mapDispatchToProps)(ApplicationFilter)



// WEBPACK FOOTER //
// ./src/routes/applications/components/ApplicationFilter.component.tsx